export default "__VITE_ASSET__C8W9oFEg__"